"use strict";

var _interopRequireDefault = require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInfomationList = getInfomationList;
var _request = _interopRequireDefault(require("@/utils/request"));
//设备信息
function getInfomationList(data) {
  return (0, _request.default)({
    url: 'equipment/query/user/equipment',
    method: 'post',
    headers: {
      "Content-Type": 'application/json',
      "x-access-token": window.localStorage.getItem('token')
    },
    data: data
  });
}